(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-reel"] && !Shopify.designMode) return;
  try {
    
(function(){
  
  const ANIM_DURATION = 1200;   
  const SCROLL_INTERVAL = 4500; 
  const SCROLL_FRACTION = 0.6;  
  

  const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

  function initFeaturedReel(root){
    if(!root) return;
    const viewport = root.querySelector('.featured-reel__viewport');
    const track    = root.querySelector('.featured-reel__track');
    const btnPrev  = root.querySelector('.featured-reel__btn.is-prev');
    const btnNext  = root.querySelector('.featured-reel__btn.is-next');
    if(!viewport || !track) return;

    let items = Array.from(track.children);
    if(items.length === 0) return;

    const GAP = parseFloat(getComputedStyle(root).getPropertyValue('--gap')) || 36;
    let itemSize = () => items[0].getBoundingClientRect().width + GAP;

    
    let autoTimer = null;
    function startAuto(){ 
      stopAuto(); 
      autoTimer = setInterval(()=> go(1), SCROLL_INTERVAL); 
    }
    function stopAuto(){ 
      if(autoTimer) clearInterval(autoTimer); 
      autoTimer = null; 
    }

    
    function animateTo(target){
      const start = track.scrollLeft;
      const delta = target - start;
      const t0 = performance.now();

      function frame(t){
        const p = Math.min((t - t0) / ANIM_DURATION, 1);
        track.scrollLeft = start + delta * easeOutCubic(p);
        if(p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function maxScroll(){ 
      return track.scrollWidth - viewport.clientWidth; 
    }

    function go(dir){
      const step = itemSize() * SCROLL_FRACTION;  
      let target = track.scrollLeft + dir * step;
      const ms = maxScroll();

      
      if(dir > 0 && track.scrollLeft >= ms - 10){ 
        
        target = 0; 
      } else if(dir < 0 && track.scrollLeft <= 10){ 
        
        target = ms; 
      } else {
        
        if(target > ms) target = ms;
        if(target < 0) target = 0;
      }

      animateTo(target);
    }

    
    if(btnPrev) btnPrev.addEventListener('click', ()=> go(-1));
    if(btnNext) btnNext.addEventListener('click', ()=> go(1));

    
    viewport.addEventListener('mouseenter', stopAuto);
    viewport.addEventListener('mouseleave', startAuto);

    
    const ro = new ResizeObserver(()=> { 
       
    });
    ro.observe(viewport);

    
    const initialPosition = 0;  
    track.scrollLeft = maxScroll() * initialPosition;

    startAuto();
  }

  function boot(){
    document.querySelectorAll('.featured-reel').forEach(initFeaturedReel);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  }else{
    boot();
  }

  
  document.addEventListener('shopify:section:load', (e)=>{
    const el = e.target.querySelector('.featured-reel');
    if(el) initFeaturedReel(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube"] && !Shopify.designMode) return;
  try {
    
(function(){
  function extractYouTubeID(input){
    if(!input) return null;
    var s = (''+input).trim();

    
    if (/^[A-Za-z0-9_-]{10,15}$/.test(s)) return s;

    
    var m = s.match(/[?&]v=([A-Za-z0-9_-]{11,15})/);
    if (m) return m[1];

    
    m = s.match(/youtu\.be\/([A-Za-z0-9_-]{11,15})/);
    if (m) return m[1];

    
    m = s.match(/youtube\.com\/embed\/([A-Za-z0-9_-]{11,15})/);
    if (m) return m[1];

    
    m = s.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{11,15})/);
    if (m) return m[1];

    return null;
  }

  function applyVideosTo(sectionEl){
    if(!sectionEl) return;
    var iframes = sectionEl.querySelectorAll('iframe[data-video]');
    iframes.forEach(function(iframe){
      var raw = iframe.getAttribute('data-video') || '';
      var id  = extractYouTubeID(raw);
      var params = 'rel=0&modestbranding=1';
      if (id){
        var newSrc = 'https://www.youtube.com/embed/' + id + '?' + params;
        if (iframe.src !== newSrc) iframe.src = newSrc; 
      } else {
        if (iframe.src !== 'about:blank') iframe.src = 'about:blank';
      }
    });
  }

  function applyAll(){
    document.querySelectorAll('section.youtube-section[data-section-id]').forEach(applyVideosTo);
  }

  
  document.addEventListener('DOMContentLoaded', applyAll);

  
  document.addEventListener('shopify:section:load', function(e){
    var sectionEl = e.target.querySelector('section.youtube-section[data-section-id]');
    applyVideosTo(sectionEl);
  });

  
  document.addEventListener('shopify:block:select', function(e){
    var sectionEl = e.target.closest('section.youtube-section[data-section-id]');
    applyVideosTo(sectionEl);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
